export default "__VITE_ASSET__BAE21Tn2__"